import { TIMEZONE_OPTIONS } from "@/lib/constants/timezones";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface TimezoneSelectProps {
  value: string;
  onChange: (tz: string) => void;
  className?: string;
}

export function TimezoneSelect({ value, onChange, className }: TimezoneSelectProps) {
  return (
    <Select value={value || "UTC"} onValueChange={onChange}>
      <SelectTrigger
        className={className}
        style={{
          backgroundColor: "var(--bg-surface)",
          borderColor: "var(--border-default)",
          color: "var(--text-primary)",
          fontSize: "var(--text-xs)",
          minWidth: 160,
          height: 32,
        }}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent
        style={{
          backgroundColor: "var(--bg-overlay)",
          borderColor: "var(--border-default)",
        }}
      >
        {TIMEZONE_OPTIONS.map((tz) => (
          <SelectItem
            key={tz.iana}
            value={tz.iana}
            style={{ fontSize: "var(--text-xs)", color: "var(--text-primary)" }}
          >
            {tz.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
